import { getGridParameters } from '~core/grigliaProvino';
import { getImageFromPage } from '~core';
import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import { jsPDF } from 'jspdf';
import { getSelectedPagesByUser } from '../getSelectedPagesByUser';
import { addWatermark } from '~src/utils';
import { getUser } from '~src/user';

export const generateGrid = async () => {
  const metadata = getMetadata();
  const gridParameters = getGridParameters();
  const selectedPagesByUser = getSelectedPagesByUser();

  const { user } = await getUser();

  const pdfGrid = new jsPDF(gridParameters.pdf.orientation, 'mm', [
    gridParameters.pdf.width,
    gridParameters.pdf.height,
  ]);

  let pageNumber = 0;

  for (let page of selectedPagesByUser) {
    pageNumber++;
    if (pageNumber > 1) {
      pdfGrid.addPage();
    }
    let image = await getImageFromPage(page);
    if (user.org_pointer.tipo_istanza === 'demo') {
      image = await addWatermark(image);
    }
    let left = gridParameters.rowInfo.padding;
    let top = gridParameters.columnInfo.padding;

    if (!gridParameters.rowInfo.outerPadding) {
      left = 0;
      top = 0;
    }

    for (let i = 0; i < gridParameters.columnInfo.maxItemsToFit; i++) {
      if (!gridParameters.rowInfo.outerPadding) {
        left = 0;
      } else {
        left = gridParameters.rowInfo.padding;
      }
      for (let j = 0; j < gridParameters.rowInfo.maxItemsToFit; j++) {
        pdfGrid.addImage(
          image,
          'JPEG',
          left,
          top,
          gridParameters.format.width,
          gridParameters.format.height
        );
        if (!gridParameters.rowInfo.innerPadding) {
          left += gridParameters.format.width;
        } else {
          left += gridParameters.format.width + gridParameters.rowInfo.padding;
        }
      }
      if (!gridParameters.rowInfo.innerPadding) {
        top += gridParameters.format.height;
      } else {
        top += gridParameters.format.height + gridParameters.columnInfo.padding;
      }
    }
  }

  const fileName = slugify(
    `Provino-${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.pdf`
  );

  return { pdfGrid, fileName };
};

export default generateGrid;
